<template>
	<div>
		<h1>Import-Parameter / Upload</h1>
		<div class="formWrapper">
			<div>
				<label for="schema">Import-Schema</label>
				<select v-model="schema" id="schema" :disabled="updateMode" @change="onSchemaChange">
					<option value="BANK">Bankauszug</option>
					<option value="JOURNAL">Journal</option>
				</select>
			</div>
			<div>
				<label for="name">Bezeichnung</label>
				<input type="text" v-model.trim="name" id="name" ref="autofocus" />
			</div>
			<div v-if="schema !== 'JOURNAL'">
				<label for="format">Format</label>
				<select v-model="format" id="format" :disabled="updateMode" @change="bank = ''">
					<option value="">-- Format auswählen --</option>
					<option value="CSV">CSV</option>
					<option value="TXT">Text</option>
					<option value="XLSX">XLSX</option>
				</select>
			</div>
			<div v-if="schema !== 'JOURNAL'">
				<label for="bank">Bank</label>
				<select v-model="bank" id="bank" :disabled="updateMode">
					<option value="">-- Bank auswählen --</option>
					<option v-show="format === 'CSV'" value="cs">CS</option>
					<option v-show="format === 'CSV'" value="kb-akb">AKB</option>
					<option v-show="format === 'CSV'" value="kb-blkb">BLKB</option>
					<option v-show="format === 'CSV'" value="kb-lukb">LUKB</option>
					<option v-show="format === 'CSV'" value="kb-zgkb">ZGKB</option>
					<option v-show="format === 'CSV'" value="pf">Postfinance</option>
					<option v-show="format === 'CSV'" value="raiffeisen">Raiffeisen</option>
					<option v-show="format === 'CSV'" value="ubs">UBS</option>
					<option v-show="format === 'TXT'" value="wechselstube">Wechselstube</option>
					<option v-show="format === 'XLSX'" value="fgb">Freie Gemeinschaftsbank FGB</option>
				</select>
			</div>
			<div v-if="schema !== 'JOURNAL'">
				<label for="acct_bank">Fibu-Konto (Bank)</label>
				<input type="text" v-model.trim="acct_bank" id="acct_bank" /><i class="fas fa-question-circle" style="margin-left: 5px;" title="Achtung! Das Bankkonto bei bereits bestehenden Kontierungen wird mit den Angaben in diesem Feld überschrieben!" v-if="updateMode"></i>
			</div>
			<div v-if="schema !== 'JOURNAL'">
				<label for="entry_txt_prefix">Präfix Buchungstext</label>
				<input type="text" v-model.trim="entry_txt_prefix" id="entry_txt_prefix" />
			</div>
			<div>
				<label for="currency_id">Währung</label>
				<select v-model="currency_id" id="currency_id" @change="forex = checkForex()">
					<option value="">-- Währung auswählen --</option>
					<option v-for="(ccy,idx) in ccys" :key="idx" :value="ccy.id">{{ ccy.code }} ({{ ccy.name }})</option>
				</select>
			</div>
			<div v-show="forex">
				<label for="exchange_rate">Buchkurs</label>
				<input type="text" v-model.trim="exchange_rate" id="exchange_rate" />
			</div>
			<div v-if="!updateMode && schema !== 'JOURNAL'" v-show="format === 'TXT'">
				<label for="srctxt">Daten</label>
				<textarea id="srctxt" v-model="srctxt"></textarea>
			</div>
			<div v-if="!updateMode">
				<label class="uploadVisible" for="fileul"><i class="fas fa-upload"></i> {{ selectedFile}}</label>
				<input class="uploadHidden" type="file" id="fileul" ref="importfile" @change="uploadFileChange" :accept="schema === 'JOURNAL' ? '.csv' : '.csv,.xlsx'" />
			</div>
			<div v-if="updateMode">
				<button @click="cancelImportShowDlg" class="btnNext">Import abbrechen</button>
				<button @click="btnNext">Weiter &gt;&gt;</button>
			</div>
			<div v-else>
				<button @click="btnNext" class="btnNext">Weiter &gt;&gt;</button>
			</div>
		</div>

		<vue-snotify></vue-snotify>
		
		<modal name="modalAbortImport" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Import abbrechen</div>
			<div class="delConf-content">
				Wenn der Import abgebrochen wird, werden die Daten nicht gespeichert.<br><br>Trotzdem abbrechen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="cancelImport" class="delConf-btn-del">Import abbrechen</button>
				<button @click="$modal.hide('modalAbortImport')">Schliessen</button>
			</div>
		</modal>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			schema: 'BANK',
			name: '',
			format: '',
			bank: '',
			currency_id: '',
			exchange_rate: '1.0000',
			acct_bank: '',
			entry_txt_prefix: '',
			srctxt: '',
			updateMode: false,
			selectedFile: 'Datei auswählen',
			forex: false,
			ccys: []
		}
	},
    methods: {
		checkForex: function () {
			for(var i = 0; i<this.ccys.length; i++) {
				if (this.ccys[i].id === this.currency_id) return !this.ccys[i].local
			}
			return false
		},
		uploadFileChange: function () {
			var f = this.$refs.importfile.files
			if (f.length > 0) {
				this.selectedFile = f[0].name
			}
		},
		onSchemaChange: function () {
			//Beim Wechsel auf JOURNAL: BANK-Felder zurücksetzen
			if (this.schema === 'JOURNAL') {
				this.format = ''
				this.bank = ''
				this.acct_bank = ''
				this.entry_txt_prefix = ''
				this.srctxt = ''
			}
			//Beim Wechsel auf BANK: Währung neu laden (falls noch nicht geladen)
			else if (this.schema === 'BANK' && this.ccys.length === 0) {
				var cid = this.$store.state.customer.id
				this.apiCall([{method: 'client/param/currency/list', param: {client_id: cid}, id: 20}], this.evalApiResponse)
			}
		},
		cancelImportShowDlg: function () {
			this.$modal.show('modalAbortImport')
		},
		cancelImport: function () {
			this.$store.commit('set_import_param', {})
			this.$router.push({ path: '/home'})
		},
		btnNext: function () {
		var vm = this
		if (vm.name === '') {
			vm.$snotify.error('Das Feld "Bezeichnung" darf nicht leer sein', 'FEHLER', {timeout: 8000})
			return
		}
		if (vm.name.length > 25) {
			vm.$snotify.error('Text im Feld "Bezeichnung" darf nicht länger als 25 Zeichen sein', 'FEHLER', {timeout: 8000})
			return
		}
			
		//JOURNAL: vereinfachter Pfad
		if (vm.schema === 'JOURNAL') {
			if (vm.currency_id === '') {
				vm.$snotify.error('Das Feld "Währung" darf nicht leer sein', 'FEHLER', {timeout: 8000})
				return
			}
			if (vm.updateMode) {
				var st = this.$store.state.import
				st.name = vm.name
				vm.$router.push({ path: '/home/import/journal'})
				return
			}
			if (vm.$refs.importfile.files.length === 0) {
				vm.$snotify.error('Keine Datei ausgewählt', 'FEHLER', {timeout: 8000})
				return
			}
			vm.forex = vm.checkForex()
			if (!vm.forex) vm.exchange_rate = '1.0000'
			var reader = new FileReader()
			reader.readAsDataURL(vm.$refs.importfile.files[0])
			reader.onload = function () {
				var p = {client_id: vm.$store.state.customer.id, name: vm.name, currency_id: vm.currency_id, exchange_rate: vm.exchange_rate, file: reader.result}
				vm.apiCall([{method: 'import/uploadjournal', param: p, id: 10}], vm.evalApiResponse)
			}
			reader.onerror = function (error) {
				vm.$snotify.error(error, 'FEHLER', {timeout: 8000})
			}
			return
		}
			
		//BANK: bestehender Pfad
		if (vm.currency_id === '') {
			vm.$snotify.error('Das Feld "Währung" darf nicht leer sein', 'FEHLER', {timeout: 8000})
			return
		}
		if (vm.entry_txt_prefix.length > 25) {
			vm.$snotify.error('Text im Feld "Präfix Buchungstext" darf nicht länger als 25 Zeichen sein', 'FEHLER', {timeout: 8000})
			return
		}
		if (vm.acct_bank === '') {
			vm.$snotify.error('Das Feld "Fibu-Konto (Bank)" darf nicht leer sein', 'FEHLER', {timeout: 8000})
			return
		}
		if (vm.acct_bank.length > 10) {
			vm.$snotify.error('Text im Feld "Fibu-Konto (Bank)" darf nicht länger als 10 Zeichen sein', 'FEHLER', {timeout: 8000})
			return
		}
			
		if (vm.updateMode) {
			var st2 = this.$store.state.import
			st2.name = vm.name
			st2.entry_txt_prefix = vm.entry_txt_prefix
			st2.exchange_rate = vm.exchange_rate
			st2.acct_bank = vm.acct_bank
				
			//Fibu-Konto (Bank) bei den bestehenden Buchungen forcieren
			for (const row of st2.rows) {
				if (row.revenue === true) {
					row.debit_acct = st2.acct_bank;
					row.debit_vat = "";
				} else {
					row.credit_acct = st2.acct_bank;
					row.credit_vat = "";
				}
			}

			vm.$router.push({ path: '/home/import/entries'})
			return
		}
			
		if (vm.format === '') {
			vm.$snotify.error('Bitte Format auswählen', 'FEHLER', {timeout: 8000})
			return
		}
		if (vm.bank === '') {
			vm.$snotify.error('Bitte Bank auswählen', 'FEHLER', {timeout: 8000})
			return
		}
			
		var forex = vm.checkForex()
		if (!forex) vm.exchange_rate = '1.0000'

		if (vm.format === 'CSV' || vm.format === 'XLSX') {
			var reader2 = new FileReader()
			if (vm.$refs.importfile.files.length === 0) {
				vm.$snotify.error('Keine Datei ausgewählt', 'FEHLER', {timeout: 8000})
				return
			}
				
			reader2.readAsDataURL(vm.$refs.importfile.files[0])
			reader2.onload = function () {
//				console.log(reader2.result)
				var p = {client_id: vm.$store.state.customer.id, name: vm.name, format: vm.format, bank: vm.bank, acct_bank: vm.acct_bank, entry_txt_prefix: vm.entry_txt_prefix, currency_id: vm.currency_id, exchange_rate: vm.exchange_rate, file: reader2.result}
				vm.apiCall([{method: 'import/upload', param: p, id: 10}], vm.evalApiResponse)
				//console.log(JSON.stringify(p))
			}
			reader2.onerror = function (error) {
				vm.$snotify.error(error, 'FEHLER', {timeout: 8000})
			}
		} else if (vm.format === 'TXT') {
			if (vm.srctxt.trim() === '') {
				vm.$snotify.error('Datenfeld darf nicht leer sein', 'FEHLER', {timeout: 8000})
				return
			}
				
			var p = {client_id: vm.$store.state.customer.id, name: vm.name, format: vm.format, bank: vm.bank, acct_bank: vm.acct_bank, entry_txt_prefix: vm.entry_txt_prefix, currency_id: vm.currency_id, exchange_rate: vm.exchange_rate, file: vm.srctxt}
			vm.apiCall([{method: 'import/upload', param: p, id: 10}], vm.evalApiResponse)
		}
	  },
		  evalApiResponse: function (resp) {
			var vm = this
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'import/upload' or 'import/uploadjournal'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$store.commit('set_import_param', value.result)
						if (value.result.schema === 'JOURNAL') {
							vm.$router.push({ path: '/home/import/journal'})
						} else {
							vm.$router.push({ path: '/home/import/entries'})
						}
					}
					break
				  case 20: // 20 = Result from 'client/param/currency/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.ccys = []
						for (var i=0; i<value.result.length; i++) {
							vm.ccys.push({id: value.result[i].id, code: value.result[i].iso_code, name: value.result[i].description === '' ? '---' : value.result[i].description, local: value.result[i].local === '1'})
						}
						vm.forex = vm.checkForex()
					}
					break
				}
			  }
			})
		}
	},
  		  mounted: function () {
  			var st = this.$store.state.import
  			this.$refs.autofocus.focus()
  			this.updateMode = st.hasOwnProperty('rows') && st.rows.length > 0
  			if (st.hasOwnProperty('schema')) this.schema = st.schema
  			if (st.hasOwnProperty('name')) this.name = st.name
  			if (st.hasOwnProperty('format')) this.format = st.format
  			if (st.hasOwnProperty('bank')) this.bank = st.bank
  			if (st.hasOwnProperty('acct_bank')) this.acct_bank = st.acct_bank
  			if (st.hasOwnProperty('entry_txt_prefix')) this.entry_txt_prefix = st.entry_txt_prefix
  			if (st.hasOwnProperty('currency_id')) this.currency_id = st.currency_id
  			if (st.hasOwnProperty('exchange_rate')) this.exchange_rate = st.exchange_rate

			var cid = this.$store.state.customer.id
			this.apiCall([{method: 'client/param/currency/list', param: {client_id: cid}, id: 20}], this.evalApiResponse)
  	    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

label {
	display: inline-block;
	width: 200px;
	vertical-align: top;
}
input, select, textarea {
	width: 300px;
	padding: 3px;
	margin-bottom: 10px;
	border: 1px solid #888;
	background: #fff;
}

.uploadVisible {
    cursor: pointer;
    font-weight: 700;
    color: white;
    background-color: #1894e3;
    display: inline-block;
	margin-left: 200px;
	margin-bottom: 10px;
	padding: 10px;
	width: 300px;
	text-align: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.uploadHidden {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.btnNext {
	margin-left: 200px;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

textarea {
	height: 200px;
}
</style>
